import { render, staticRenderFns } from "./CreateCompetition.vue?vue&type=template&id=38261748&scoped=true"
import script from "./CreateCompetition.vue?vue&type=script&lang=js"
export * from "./CreateCompetition.vue?vue&type=script&lang=js"
import style0 from "./CreateCompetition.vue?vue&type=style&index=0&id=38261748&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38261748",
  null
  
)

export default component.exports